import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: process.env.VUE_APP_IS_ELECTRON === 'true' ? 'hash' : 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const status = store.getters['auth/status']
  const homePage = store.getters['auth/homePage']
  if (to.matched.some(record => record.meta.keycloakRequired) && store.state.auth.activeKeycloak === 'SI') {
    if (!Vue.$keycloak.authenticated) {
      Vue.$keycloak.login({ redirectUri: window.location.href })
    } else {
      if (Vue.$keycloak.tokenParsed.preferred_username !== store.state.auth.user.user && to.name === 'login') {
        function validateCompany (url) {
          const dominio = url.split('.')[1]
          const subdominio = url.split('.')[0]
          if (subdominio === 'localhost') {
            return 'bea360'
          } else if (subdominio === 'devdesk') {
            return 'devportal'
          } else {
            if (dominio === 'beaware360') {
              return `${subdominio.slice(0, -4)}portal`
            } else {
              return subdominio
            }
          }
        }
        const url = window.location.hostname
        Promise.resolve(store.dispatch('auth/loginByKeycloak',
          [validateCompany(url),
            Vue.$keycloak.tokenParsed.email,
            Vue.$keycloak.tokenParsed.preferred_username,
            Vue.$keycloak.token
          ])).then(() => {
          store.commit('auth/setLang', store.state.auth.user.language)
        })
      }
    }
  }
  if (to.matched.some(record => record.meta.requiresGuest) && status) {
    next(from.name ? false : homePage)
  } else if (to.matched.some(record => record.meta.requiresAuth) && !status) {
    next({ name: 'login', query: to.fullPath !== '/' ? { redirect: to.fullPath.replace(/^\//g, '') } : null })
  } else if (to.matched.some(record => record.meta.withoutPermissions)) {
    next()
  } else {
    const index = to.name.indexOf('.')
    const name = index >= 0 ? to.name.substr(0, index) : to.name
    const permissions = store.getters['auth/permissions'][name]
    if (!permissions || !permissions.listar || (to.name.indexOf('.nuevo') >= 0 && !permissions.crear) || (to.name.indexOf('.editar') >= 0 && !permissions.modificar && !permissions.ver)) {
      next(from.name ? { name: from.name } : homePage)
    } else {
      /**
             * Esta condición resetea los estilos realizados al expandir la pantalla en vista 360
             * por lo que al navegar en otras pestañas los estilos vuelven a la normalidad
             */
      if (store.getters['casos/expanded'] !== false) {
        store.commit('casos/setExpand', !store.getters['casos/expanded'])
      }
      next()
    }
  }
})

export default router
